import {Ng1Controller, StateService, TargetState, Transition} from "@uirouter/angularjs";
import {DataHubService} from "../../modules/DataHubModule";
import {DisposeBag} from "../../modules/DisposeBag";
import {DebounceFactory} from "../../modules/DebounceModule";
import {IToasterService} from "ngtoaster";
import {SpinnerService} from "../../modules/SpinnerModule";
import * as angular from "angular";
import {ConfigService} from "../../modules/ConfigModule";
import {ActivityDto} from "../../model/ActivityDto";
import {ActivityFullDto} from "../../model/ActivityFullDto";
import {ActivityTimeDto} from "../../model/ActivityTimeDto";
import {ActivityUpdateDto} from "../../model/ActivityUpdateDto";
import {ActivityFollowupDto} from "../../model/ActivityFollowupDto";
import {isNumber, isString} from "angular";
import * as moment from "moment";

export default class EditController implements Ng1Controller {
    private record: ActivityFullDto;
    private followUp: ActivityFollowupDto;
    private disposeBag = new DisposeBag();
    private timeModel: ActivityTimeDto;

    $onInit(): void {
        console.log('$onInit');

    }

    uiCanExit(transition: Transition): boolean | TargetState | void | Promise<boolean | TargetState | void> {
        this.disposeBag.finalize();
        return undefined;
    }

    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
        console.debug('uiOnParamsChanged', newValues, $transition$);
        this.$stateParams = newValues;
    }

    constructor(private $dataHub: DataHubService,
                private $state: StateService,
                private $stateParams: any,
                private $debounce: DebounceFactory,
                private toaster: IToasterService,
                private $spinner: SpinnerService,
                private $config: ConfigService) {
        $dataHub.onConnected(this.refresh, this.disposeBag);
        this.$dataHub.onActivityFullUpdated(x => this.record = x, this.disposeBag);
    }

    refresh = () => {
        if (!this.$dataHub.isConnected) return;
        this.refreshDebounce();
    };

    refreshDebounce = this.$debounce(() => {
        this.$dataHub.activityFullSubscribeAndQuery(this.$stateParams.activityGuid)
            .then(ret => this.record = ret)
            .catch(this.$dataHub.defaultErrorHandler);
    }, 1000, true);


    save = () => {
        let dto = <ActivityUpdateDto><unknown>this.record;
        this.$dataHub.activityUpdate(dto)
            .then(() => {
                if(this.followUp) return this.$dataHub.activityCreateFollowup(this.followUp).catch(this.$dataHub.defaultErrorHandler);
            })
            .then(() => {
                window.close();
                window.history.back();
            })
            .catch(this.$dataHub.defaultErrorHandler);
    }

    delete = () => {
        // this.$dataHub.contactDelete(this.contact)
        //     .then(() => this.close())
        //     .catch(this.$dataHub.defaultErrorHandler);
    }
    private _activityStatus: string;

    get canDelete(): boolean {
        // if(this.resolve.contact.qbPrimary) return false;
        // if(this.contact.guid) return true;
        return false;
    }

    start() {
        this.$dataHub.activityStart(this.record.guid)
            .catch(this.$dataHub.defaultErrorHandler);
    }

    pause() {
        this.$dataHub.activityStop(this.record.guid)
            .catch(this.$dataHub.defaultErrorHandler);
    }

    complete() {
        this.$dataHub.activityComplete(this.record.guid)
            .catch(this.$dataHub.defaultErrorHandler);
    }

    timeEdit(row: ActivityTimeDto) {
        this.timeModel = angular.copy(row);
    }

    timeDelete() {
        this.$dataHub.activityTimeDelete(this.timeModel)
            .then(() => this.timeModel = null)
            .catch(this.$dataHub.defaultErrorHandler);
    }

    timeUpdate() {
        this.$dataHub.activityTimeUpdate(this.timeModel)
            .then(() => this.timeModel = null)
            .catch(this.$dataHub.defaultErrorHandler);
    }

    get now() {
        return Date.now();
    }

    createFollowUp() {
        if (!this.followUp) this.followUp = new ActivityFollowupDto();
        if (!this.followUp.previousActivity) this.followUp.previousActivity = this.record;
        if (!this.followUp.contact) this.followUp.contact = this.record.contact;
        if (!this.followUp.assignedTo) this.followUp.assignedTo = this.record.assignedTo;
        if (!this.followUp.activityType) this.followUp.activityType = this.record.activityType;
    }

    setFollowUp(interval) {
        let m = moment().startOf('hour');
        if (isNumber(interval)) {
            m = m.add(interval, 'days');
        }
        if (isString(interval)) {
            m = m.add(1, 'week');
            m = m.day(interval);
        }

        this.followUp.timeScheduled = m.toDate();
    }

    get activityStatus() {
        if (this._activityStatus) return this._activityStatus;

        if (this.record.followUps.length>0 && this.record.timeCompleted) {
            return 'completedWithFollowUp';
        }
        if (this.record.timeCompleted) {
            return 'completed';
        }
        return 'incomplete';
    }

    set activityStatus(value: string) {
        this._activityStatus = value;
        switch (value) {
            case 'incomplete':
                this.record.timeCompleted = null;
                break;
            case 'completed':
                if (!this.record.timeCompleted) this.record.timeCompleted = new Date();
                this.followUp = null;
                break;
            case 'completedWithFollowUp':
                if (!this.record.timeCompleted) this.record.timeCompleted = new Date();
                this.createFollowUp();
                break;
        }

    }

    get clockRunning(): boolean {
        return this.record.timeEntries.some(x => x.timeEnd == null);
    }


}
